/* eslint-disable no-template-curly-in-string */

import * as yup from "yup"

var schema = yup.object().shape({
    comment: yup
        .string()
        .nullable()
        .min(2, "Comment should contain atleast ${min} characters")
        .max(250, "Maximum length for Comment should be ${max} characters"),
})

export default schema;